module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/hero_mob-eeaf3362648112a3a39122f66169c3ff.jpg";